<template>
    <div class="card p-pb-6">
        <Toast />

        <form>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <h5>
                        <b>{{ $t('OtherPlatform.Add.Heading') }}</b>
                    </h5>
                    <h5>
                        <b>{{ $t('OtherPlatform.Add.Heading2') }}</b>
                    </h5>
                    <h5 id="subhead">(기업정보를 확인해 주세요)</h5>
                    <div class="card company p-shadow-none p-mb-0">
                        <div class="p-grid p-formgrid p-mb-3">
                            <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                                <label for="title2"
                                    ><b>{{ $t('OtherPlatform.Add.ManagerName') }}</b
                                    ><span class="redRequired">*</span></label
                                >
                                <InputText :class="`${error.mName ? 'p-invalid' : ''}`" type="text" :placeholder="$t('OtherPlatform.Add.SBManagerName')" id="title2" v-model="PersonName" @keydown.space="preventLeadingSpace" disabled></InputText>
                                <small class="text-red">{{ error.mName }}</small>
                                <div class="p-pt-2">
                                    <input type="checkbox" value="privateName" name="privateName" v-model="privatename" />
                                    <label for="privateName" id="lbl2">{{ $t('OtherPlatform.Add.Private') }}</label>
                                </div>
                            </div>
                            <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                                <label for="title2"
                                    ><b>{{ $t('OtherPlatform.Add.ManagerContact') }}</b
                                    ><span class="redRequired">*</span></label
                                >
                                <InputText
                                    :class="`${error.mContact ? 'p-invalid' : ''}`"
                                    type="text"
                                    :placeholder="$t('OtherPlatform.Add.SBManagerContact')"
                                    id="title2"
                                    v-model="PersonContact"
                                    @keydown.space="preventLeadingSpace"
                                    disabled
                                ></InputText>
                                <small class="text-red">{{ error.mContact }}</small>
                                <div class="p-pt-2">
                                    <input type="checkbox" value="privateContact" name="privateContact" v-model="privatecontact" />
                                    <label for="privateContact" id="lbl2">{{ $t('OtherPlatform.Add.Private') }} </label>
                                </div>
                            </div>
                            <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                                <label for="title2"
                                    ><b>{{ $t('OtherPlatform.Add.ManagerEmail') }}</b
                                    ><span class="redRequired">*</span></label
                                >
                                <InputText :class="`${error.mEmail ? 'p-invalid' : ''}`" type="text" :placeholder="$t('OtherPlatform.Add.SBManagerEmail')" id="title2" v-model="PersonEmail" @keydown.space="preventLeadingSpace" disabled></InputText>
                                <small class="text-red">{{ error.mEmail }}</small>
                                <div class="p-pt-2">
                                    <input type="checkbox" value="privateEmail" name="privateEmail" v-model="privateemail" />
                                    <label for="privateEmail" id="lbl2">{{ $t('OtherPlatform.Add.Private') }} </label>
                                </div>
                            </div>
                        </div>

                        <div class="p-grid p-formgrid p-mb-3 p-mt-4">
                            <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                                <div class="align-items-center p-mb-3">
                                    <RadioButton v-model="AddressCheck" inputId="defaultAddress" name="address" value="defaultAddress" class="p-mr-2" />
                                    <label for="defaultAddress" class="p-mr-2"
                                        ><b>{{ $t('OtherPlatform.Add.CompanyAddress') }}</b
                                        ><span class="redRequired">*</span></label
                                    >
                                </div>
                                <div>
                                    <InputText type="text" :placeholder="$t('OtherPlatform.Add.AddressPlace')" v-model="dAddress" disabled></InputText><br /><br />
                                    <InputText type="text" :placeholder="$t('OtherPlatform.Add.PostalPlace')" v-model="dPostcode" disabled></InputText>
                                </div>
                            </div>

                            <div class="p-col-12 p-mb-2 p-lg-6 p-mb-lg-0 p-field">
                                <div class="align-items-center p-mb-3">
                                    <RadioButton inputId="newAddress" v-model="AddressCheck" name="address" value="newAddress" class="p-mr-2" />
                                    <label for="newAddress"
                                        ><b>{{ $t('OtherPlatform.Add.NewAddress') }}</b></label
                                    >
                                </div>
                                <div>
                                    <InputText :class="`${error.cAddr ? 'p-invalid' : ''}`" type="text" :placeholder="$t('OtherPlatform.Add.AddressPlace')" v-model="nAddress" disabled></InputText>
                                    <small class="text-red">{{ error.cAddr }}</small>
                                    <InputText class="p-mt-2" :class="`${error.cPIN ? 'p-invalid' : ''}`" type="text" :placeholder="$t('OtherPlatform.Add.PostalPlace')" v-model="nPostcode" disabled></InputText>
                                    <small class="text-red">{{ error.cPIN }}</small>
                                    <div class="p-pt-2">
                                        <input type="checkbox" value="privateAddress" name="privateAddress" v-model="privateaddress" />
                                        <label for="privateAddress" id="lbl2">{{ $t('OtherPlatform.Add.Private') }} </label>
                                    </div>
                                </div>
                            </div>
                            <div class="p-col-12 p-mb-2 p-lg-2 p-mb-lg-0 p-field" id="btnss">
                                <Button :label="$t('OtherPlatform.Add.FindAddress')" class="p-button p-component p-button" id="find" @click="Adressmodal = true"></Button>
                            </div>
                        </div>
                        <div class="p-grid p-formgrid p-mb-3">
                            <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                                <label for="DetailAddress"
                                    ><b>{{ $t('OtherPlatform.Add.DetailAddress') }}</b></label
                                >
                                <InputText type="text" :placeholder="$t('OtherPlatform.Add.DetailPlace')" v-model="job_detail_address"></InputText>
                            </div>
                        </div>
                    </div>
                    <h5>
                        <b>{{ $t('OtherPlatform.Add.Heading3') }}</b>
                    </h5>
                    <h5 id="subhead">(원하시는 인재가 업무할 정보를 입력해 주세요)</h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="nameuser"
                                ><b>{{ $t('OtherPlatform.Add.Gender') }}</b
                                ><span class="redRequired">*</span></label
                            >
                            <Dropdown v-model="gender" :options="Genderdropdown" optionLabel="name" optionValue="code" :placeholder="$t('OtherPlatform.list.Select')" name="first_category" id="first_category" />
                            <div class="text-red">{{ error.phone }}</div>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-7 p-mb-lg-0 p-field" id="triple">
                            <div class="p-grid p-formgrid p-mb-3 p-custom-grid-lg">
                                <!-- Age field -->
                                <label for="nameuser"
                                    ><b id="ages">{{ $t('OtherPlatform.Add.Age') }}</b
                                    ><span class="redRequired">*</span></label
                                >
                                <div>
                                    <input type="checkbox" v-model="checkAgebetw" @change="checkAgebetw == true ? (age_between = false) : (age_between = true), (startAge = ''), (endAge = '')" id="MS" value="2" name="MS" class="check" />
                                    <label for="2" id="lbl">{{ $t('OtherPlatform.Add.AnyAge') }}</label>
                                </div>
                                <!-- Manual div field -->
                                <div v-if="age_between" style="display: flex">
                                    <div>
                                        <InputText
                                            style="width: 80%"
                                            :class="`${error.mnAge ? 'p-invalid' : ''}`"
                                            type="text"
                                            :placeholder="$t('OtherPlatform.Add.MinAge')"
                                            id="Age"
                                            v-model="startAge"
                                            @keypress="onlyNumber($event)"
                                            maxlength="2"
                                            @blur="checkAgeOrder"
                                            @keyup="ClearError($event)"
                                        ></InputText>
                                        <br />
                                        <small class="text-red" id="valid1">{{ error.mnAge }}{{ errage }}</small>
                                    </div>
                                    <span class="p-pt-5">~</span>
                                    <div>
                                        <InputText
                                            style="width: 80%"
                                            :class="`${error.mxAge ? 'p-invalid' : ''}`"
                                            type="text"
                                            :placeholder="$t('OtherPlatform.Add.MaxAge')"
                                            id="Age"
                                            v-model="endAge"
                                            @keypress="onlyNumber($event)"
                                            maxlength="2"
                                            @blur="checkAgeOrder"
                                            @keyup="ClearError($event)"
                                        ></InputText
                                        ><br />
                                        <small class="text-red" id="valid1">{{ error.mxAge }}</small>
                                    </div>
                                </div>
                                <div class="d-flex">
                                    <div id="checktext">
                                        <input type="checkbox" id="Middle-Aged-Recruitment" value="2" name="MS" class="Middle-Aged-Recruitment" v-model="middle_age" />
                                        <label for="2" id="lbl2">{{ $t('OtherPlatform.Add.Middle-Aged-Recruitment') }}</label
                                        ><br />
                                        <small class="text-info1">(중장년층 채용으로 설정하시면 실버벨 공고로 자동 노출됩니다.)</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h5>
                        <b>{{ $t('OtherPlatform.Add.Heading4') }}</b>
                    </h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <!-- <div class="p-col-12 p-mb-2 p-lg-2 p-mb-lg-0 p-field">
                            <input type="radio" id="bg" value="2" name="MS" />
                            <label for="2"
                                ><b>{{ $t('OtherPlatform.Add.noacademicbackground') }}</b></label
                            >
                            <div class="text-red">{{ error.email }}</div>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <input type="radio" id="ac" value="2" name="MS" />
                            <label for="2"
                                ><b>{{ $t('OtherPlatform.Add.Selectacademicqualifications') }}</b></label
                            >
                            <div class="text-red">{{ error.email }}</div>
                        </div> -->
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <div class="align-items-center p-mb-3">
                                <RadioButton v-model="educationLevel" inputId="noeducation" name="education" value="no_academic_background" class="p-mr-2" @change="checkeducation()" />
                                <label for="noeducation" class="p-mr-2"
                                    ><b>{{ $t('OtherPlatform.Add.noacademicbackground') }}</b></label
                                >
                            </div>
                        </div>

                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <div class="align-items-center p-mb-3">
                                <RadioButton inputId="education" v-model="educationLevel" name="education" value="educated" class="p-mr-2" @change="checkeducation()" />
                                <label for="education"
                                    ><b>{{ $t('OtherPlatform.Add.Selectacademicqualifications') }}</b></label
                                >
                            </div>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field" v-show="showEdcnLevel">
                            <Dropdown v-model="selectededucation" :options="Qualificationdropdown" optionLabel="text" optionValue="value" :placeholder="$t('OtherPlatform.list.Select')" name="first_category" id="first_category" />
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="nameuser"
                                ><b>{{ $t('OtherPlatform.Add.jobselection') }}</b
                                ><span class="redRequired">*</span></label
                            >
                            <!-- <Dropdown
                                :class="`${error.jobSelect ? 'p-invalid' : ''}`"
                                v-model="status"
                                :options="statusdropdown"
                                optionLabel="name"
                                optionValue="code"
                                :placeholder="$t('OtherPlatform.list.Select')"
                                name="first_category"
                                id="first_category"
                                @click="jobselectModal = true"
                            /> -->
                            <span class="p-input-icon-right" @click="jobselectModal = true">
                                <i class="p-dropdown-trigger-icon pi pi-chevron-down" />
                                <InputText v-model="status" :placeholder="$t('OtherPlatform.list.Select')" :class="`${error.jobSelect ? 'p-invalid' : ''}`" readonly @select="ClearError($event)" />
                            </span>

                            <Tag class="p-mr-3 p-mb-2 p-mt-2" v-for="(i, e) in selectedjobArray" :key="e">
                                <div class="align-items-center gap-2">
                                    <span class="text-base">{{ i }}</span>
                                    <i class="pi pi-times text-xs" @click="removeFilter1(i, $event)"></i>
                                </div>
                            </Tag>

                            <small class="text-red">{{ error.jobSelect }}</small>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="nameuser"
                                ><b>{{ $t('OtherPlatform.Add.preferentialconditions') }}</b></label
                            >
                            <span class="p-input-icon-right" @click="prefmodal = true">
                                <i class="p-dropdown-trigger-icon pi pi-chevron-down" />
                                <InputText v-model="status" :placeholder="$t('OtherPlatform.list.Select')" readonly />
                            </span>
                            <!-- <Dropdown @click="prefmodal = true" v-model="status" :options="statusdropdown" optionLabel="name" optionValue="code" :placeholder="$t('OtherPlatform.list.Select')" name="first_category" id="first_category" /> -->
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="2"
                                ><b>{{ $t('OtherPlatform.Add.Areaofrecruitment') }} </b><span class="redRequired">*</span></label
                            >
                            <InputText v-model.trim="areaRecruitment" :class="`${error.jobRequirement ? 'p-invalid' : ''}`" type="text" :placeholder="$t('OtherPlatform.Add.AreaPlace')" id="title2" @keyup="ClearError($event)"></InputText>
                            <small class="text-red">{{ error.jobRequirement }}</small>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field" v-show="noOfPeople_visible">
                            <label for="2"
                                ><b>{{ $t('OtherPlatform.Add.Noofrecruitment') }}</b
                                ><span class="redRequired">*</span></label
                            >
                            <InputText
                                :class="`${error.jobNopeople ? 'p-invalid' : ''}`"
                                v-model.trim="noOfPeople"
                                @keypress="onlyNumber($event)"
                                type="text"
                                :placeholder="$t('OtherPlatform.Add.NoOfPlace')"
                                id="title2"
                                maxlength="3"
                                @keyup="ClearError($event)"
                            ></InputText>
                            <small class="text-red">{{ error.jobNopeople }}</small>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <input type="checkbox" id="ap" value="2" name="MS" v-model="checknoPeople" @change="checknoPeople == true ? (noOfPeople_visible = false) : (noOfPeople_visible = true)" />
                            <label for="2" id="long">{{ $t('OtherPlatform.Add.PeopleText') }}</label>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-12 p-mb-lg-0 p-field">
                            <label for="2" class="p-mb-0"
                                ><b>{{ $t('OtherPlatform.Add.Responsibilities') }}</b
                                ><span class="redRequired">*</span></label
                            >
                            <textarea
                                :class="`${error.responsibility ? 'p-invalid' : ''}`"
                                type="text"
                                :placeholder="$t('OtherPlatform.Add.DescPlace')"
                                id="title2"
                                v-model.trim="responsible"
                                @keydown.space="preventLeadingSpace"
                                style="width: 100%; margin-left: 0px; margin-top: 14px"
                                rows="5"
                                cols="30"
                                @keyup="ClearError($event)"
                            ></textarea>
                            <small class="text-red">{{ error.responsibility }}</small>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-12 p-mb-lg-0 p-field">
                            <label for="2" class="p-mb-0"
                                ><b>{{ $t('OtherPlatform.Add.elligibilities') }}</b
                                ><span class="redRequired">*</span></label
                            >
                            <textarea
                                :class="`${error.qualification ? 'p-invalid' : ''}`"
                                type="text"
                                :placeholder="$t('OtherPlatform.Add.DescPlace1')"
                                id="title2"
                                v-model.trim="eligibility"
                                @keydown.space="preventLeadingSpace"
                                style="width: 100%; margin-left: 0px; margin-top: 14px"
                                rows="5"
                                cols="30"
                                @keyup="ClearError($event)"
                            ></textarea>
                            <small class="text-red">{{ error.qualification }}</small>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="nameuser"
                                ><b>{{ $t('OtherPlatform.Add.Career') }}</b></label
                            >
                            <Dropdown
                                @change="showCarrierField"
                                v-model="carrer"
                                :options="Careerdropdown"
                                optionLabel="name"
                                optionValue="code"
                                :placeholder="$t('OtherPlatform.list.Select')"
                                name="first_category"
                                id="first_category"
                                :disabled="regardlessAny === true ? true : false"
                            />
                        </div>
                        <div v-show="carrerField" class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="subtitle2" id="match" style="color: transparent; opacity: 0"> 0 </label>
                            <div class="p-inputgroup">
                                <InputText v-model.trim="min_exper" @keypress="onlyNumber($event)" :placeholder="$t('OtherPlatform.Add.MinExp')" :class="`${error.minExp ? 'p-invalid' : ''}`" :disabled="regardlessAny === true ? true : false" />
                                <span class="p-inputgroup-addon">년 이상</span>
                            </div>
                            <small class="text-red">{{ error.minExp }}</small>
                        </div>
                        <div v-show="carrerField" class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="subtitle2" id="match" style="color: transparent; opacity: 0"> 0 </label>
                            <div class="p-inputgroup">
                                <InputText @keypress="onlyNumber($event)" v-model.trim="max_exper" :placeholder="$t('OtherPlatform.Add.MaxExp')" :class="`${error.maxExp ? 'p-invalid' : ''}`" :disabled="regardlessAny === true ? true : false" />
                                <span class="p-inputgroup-addon">년 이하</span>
                            </div>
                            <small class="text-red">{{ error.maxExp }}</small>
                        </div>
                        <div class="p-lg-3 p-field" v-show="carrerField">
                            <input type="checkbox" value="2" name="MS" v-model="regardlessAny" @change="regardlessAny == true ? (hidecarrers = false) : (hidecarrers = true)" />
                            <label for="2" id="lbl3">{{ $t('OtherPlatform.Add.Anycareertraining') }}</label
                            ><br />
                            <small>(경력인재를 경력 연수에 상관 없이 뽑고 싶을 때 선택하세요)</small>
                        </div>
                    </div>
                    <h5>
                        <b>{{ $t('OtherPlatform.Add.Heading5') }}</b>
                    </h5>
                    <h5 id="subhead">(인재가 근무하게 될 근무조건을 입력해 주세요)</h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="nameuser"
                                ><b>{{ $t('OtherPlatform.Add.WorkType') }}</b
                                ><span class="redRequired">*</span></label
                            >
                            <Dropdown
                                :class="`${error.wType ? 'p-invalid' : ''}`"
                                v-model="selectedWorkingType"
                                :options="workingType"
                                optionLabel="text"
                                optionValue="value"
                                :placeholder="$t('OtherPlatform.Add.Select')"
                                name="first_category"
                                id="first_category"
                                @change="ClearError($event)"
                            />
                            <small class="text-red">{{ error.wType }}</small>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="nameuser"
                                ><b>{{ $t('OtherPlatform.Add.Probation') }}</b></label
                            >
                            <InputText :class="`${error.email ? 'p-invalid' : ''}`" type="text" :placeholder="$t('OtherPlatform.Add.ProbPlace')" id="title2" v-model.trim="probabation" @keypress="onlyNumber($event)" maxlength="2"></InputText>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="nameuser"
                                ><b>{{ $t('OtherPlatform.Add.WorkPeriod') }}</b
                                ><span class="redRequired">*</span></label
                            >
                            <Dropdown
                                :class="`${error.wPeriod ? 'p-invalid' : ''}`"
                                v-model="selectedWorkingPeriod"
                                :options="workingPeriod"
                                optionLabel="text"
                                optionValue="value"
                                :placeholder="$t('OtherPlatform.Add.Select')"
                                name="first_category"
                                id="first_category"
                                @change="ClearError($event)"
                            />
                            <small class="text-red">{{ error.wPeriod }}</small>
                            <div style="margin-top: 10px">
                                <input type="checkbox" value="2" name="MS" v-model="negoWorkperiod" />
                                <label for="2" id="lbl2" class="error-msgs">{{ $t('OtherPlatform.Add.Negotiable') }}</label>
                            </div>
                        </div>
                    </div>

                    <div class="p-grid p-formgrid p-mb-3 test">
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="nameuser"
                                ><b>{{ $t('OtherPlatform.Add.WorkingDay') }}</b
                                ><span class="redRequired">*</span></label
                            >
                            <div class="p-col-12 p-mb-2 p-lg-8 p-mb-lg-0 p-field" id="flexradio" style="padding: 0px; justify-content: flex-start; gap: 10px">
                                <input type="radio" value="selectday" name="MS" v-model="WorkingDay" />
                                <label for="2" id="txtlbl">{{ $t('OtherPlatform.Add.Selectday') }}</label>
                                <input type="radio" value="negotiate" name="MS" v-model="WorkingDay" @change="checkedDays = []" />
                                <label for="2" id="txtlbl">{{ $t('OtherPlatform.Add.Negotiate') }}</label>
                                <div class="text-red">{{ error.email }}</div>
                            </div>
                            <div class="p-col-12 p-md-12" id="reason" v-if="WorkingDay !== 'selectday'"></div>
                            <div class="p-grid p-formgrid p-mb-3" v-else>
                                <div class="p-col-12 p-mb-2 p-lg-12 p-mb-lg-0 p-field" id="Flexchecks">
                                    <br />
                                    <!-- <Dropdown v-model="dropdownValue" modelValue="dropdownValues[0].name" :options="dropdownValues" optionLabel="code" :placeholder="status" /> -->
                                    <div id="accesscheck">
                                        <div v-for="mainCat in workingDays" :key="mainCat.val">
                                            <input
                                                type="checkbox"
                                                :value="mainCat.val"
                                                :id="mainCat.val"
                                                v-model="checkedDays"
                                                @click="check($event)"
                                                :disabled="checkedDays.length >= max && checkedDays.indexOf(index) == -1"
                                                @change="ClearError($event)"
                                            />
                                            <label :for="mainCat.val">{{ mainCat.dayName }}</label>
                                        </div>
                                        &nbsp;&nbsp;
                                        <br />
                                    </div>
                                </div>
                                <small class="text-red" id="error">{{ error.wdays }}</small>
                                <small class="text-info">(요일은 최대 6일까지 선택 가능합니다)</small>
                            </div>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="nameuser"
                                ><b>{{ $t('OtherPlatform.Add.WorkingHour') }}</b
                                ><span class="redRequired">*</span></label
                            >
                            <div class="flex" style="flex-wrap: wrap">
                                <div class="p-col-12 p-mb-2 p-lg-6 p-mb-lg-0 p-field">
                                    <!-- <Calendar
                                        :class="`${error.wrkHrfrm ? 'p-invalid' : ''}`"
                                        id="calendar-timeonly"
                                        v-model="workhrFrom"
                                        timeOnly
                                        class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field"
                                        style="width: 100%"
                                        :placeholder="$t('OtherPlatform.Add.StartTime')"
                                        @date-select="ClearError($event)"
                                    /> -->
                                    <input v-model="workhrFrom" type="time" name="MS" :class="`${error.wrkHrfrm ? 'p-invalid' : ''}`" class="p-inputtext p-component" @input="ClearError($event)" @change="validateTime" />
                                    <small class="text-red">{{ error.wrkHrfrm }}</small>
                                </div>
                                <div class="p-col-12 p-mb-2 p-lg-6 p-mb-lg-0 p-field">
                                    <!-- <Calendar
                                        :class="`${error.wrkHrto ? 'p-invalid' : ''}`"
                                        id="calendar-timeonly"
                                        v-model="workhrTo"
                                        timeOnly
                                        class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field"
                                        :placeholder="$t('OtherPlatform.Add.EndTime')"
                                        style="width: 100%"
                                        @date-select="ClearError($event)"
                                    /> -->
                                    <input v-model="workhrTo" class="p-inputtext p-component" type="time" name="MS" :class="`${error.wrkHrto ? 'p-invalid' : ''}`" @input="ClearError($event)" @change="validateTime1" />
                                    <small class="text-red">{{ error.wrkHrto }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="nameuser"
                                ><b>{{ $t('OtherPlatform.Add.BreakTime') }}</b></label
                            >
                            <div class="flex" style="flex-wrap: wrap">
                                <div class="p-col-12 p-mb-2 p-lg-6 p-mb-lg-0 p-field">
                                    <input v-show="workHr" v-model="BreakhrFrom" class="p-inputtext p-component" type="time" name="MS" @change="validateTime2" />
                                    <!-- <Calendar v-show="workHr" :placeholder="$t('OtherPlatform.Add.StartTime')" id="calendar-timeonly" v-model="BreakhrFrom" timeOnly class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field" style="width: 100%" /> -->
                                </div>
                                <div class="p-col-12 p-mb-2 p-lg-6 p-mb-lg-0 p-field">
                                    <input v-show="workHr" v-model="BreakhrTo" class="p-inputtext p-component" type="time" name="MS" @change="validateTime3" />
                                    <!-- <Calendar v-show="workHr" :placeholder="$t('OtherPlatform.Add.EndTime')" id="calendar-timeonly" v-model="BreakhrTo" timeOnly class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field" style="width: 100%" /> -->
                                </div>
                                <div style="margin: 10px">
                                    <input @change="breakControl()" v-model="nobreak" type="checkbox" id="bg" value="1" name="MS" />
                                    <label for="6" id="dxts">{{ $t('OtherPlatform.Add.Nobreaktime') }}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="2"
                                ><b>{{ $t('OtherPlatform.Add.prescribedworkinghours') }}</b
                                ><span class="redRequired">*</span></label
                            >

                            <div class="p-inputgroup flex-1">
                                <span class="p-inputgroup-addon">{{ $t('OtherPlatform.Add.Weekly') }} </span>
                                <InputText :class="`${error.pWorkHr ? 'p-invalid' : ''}`" v-model.trim="prescribedWorkHours" placeholder="40" @keypress="onlyNumber($event)" maxlength="3" @keyup="ClearError($event)" />
                                <span class="p-inputgroup-addon"> {{ $t('OtherPlatform.Add.Hours') }} </span>
                            </div>
                            <small class="text-red">{{ error.pWorkHr }}</small>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="nameuser"
                                ><b>{{ $t('OtherPlatform.Add.Pay') }}</b
                                ><span class="redRequired">*</span></label
                            >
                            <Dropdown v-model="payType" :options="payTypes" optionLabel="text" optionValue="value" :placeholder="$t('OtherPlatform.list.Select')" name="first_category" id="first_category" />
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="subtitle2" id="match" style="color: transparent; opacity: 0"> 0 </label>
                            <div class="p-inputgroup">
                                <InputText :class="`${error.salary ? 'p-invalid' : ''}`" v-model.trim="Paysalary" :placeholder="$t('OtherPlatform.Add.EXCTC')" @keypress="onlyNumber($event)" maxlength="9" @keyup="ClearError($event)" />
                                <span class="p-inputgroup-addon"> &#8361; </span>
                            </div>
                            <small class="text-red mt-error">{{ error.salary }}</small>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3"></div>
                    <h5>
                        <b>{{ $t('OtherPlatform.Add.Heading6') }}</b>
                    </h5>
                    <h5 id="subhead">(지원자가 지원할 공고에 대한 정보를 입력해 주세요)</h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="nameuser"
                                ><b>{{ $t('OtherPlatform.Add.AnnounceTitle') }}</b
                                ><span class="redRequired">*</span></label
                            >
                            <InputText :class="`${error.atitle ? 'p-invalid' : ''}`" type="text" :placeholder="$t('OtherPlatform.Add.TitlePlace')" v-model="anTitle" @keydown.space="preventLeadingSpace" @keyup="ClearError($event)"></InputText>
                            <small class="text-red">{{ error.atitle }}</small>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="nameuser"
                                ><b>{{ $t('OtherPlatform.Add.NoticePosting') }}</b
                                ><span class="redRequired">*</span></label
                            >
                            <Dropdown @change="directInput()" v-model="NoticePostPeriod" :options="noticePostingPeriod" optionLabel="text" optionValue="value" :placeholder="$t('OtherPlatform.list.Select')" name="first_category" id="first_category" />
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="subtitle2" id="mainbg">
                                {{ $t('OtherPlatform.Add.MainImage') }}
                            </label>
                            <p id="subhead">(공고가 올라갈 때 메인 화면에 보여지는 대표사진입니다)</p>
                            <!-- file upload field thumbnail  -->
                            <div :class="`${error.file ? 'custom-select-invalid' : 'custom-select'}`">
                                <!-- <span v-if="old_file && !fileName">{{ old_file }}</span> -->
                                <span v-if="!fileName">{{ $t('OtherPlatform.Add.fileupload') }}</span>
                                <span v-else>{{ fileName }}</span>
                                <!-- <span v-if="!fileName">파일 선택</span>
                                <span v-else>{{ fileName }}</span> -->

                                <input type="file" class="select-file" accept="image/*" :multiple="true" @change="FileChangeThumnail($event)" />
                                <Button :label="$t('OtherPlatform.Add.ChooseFile')" class="SelectBtn n-wrap" />
                            </div>

                            <span class="img-info">* {{ $t('OtherPlatform.Add.IMGINFO') }}</span>
                            <br />
                            <div class="text-red">{{ addthumbnaildata.maxImagelengthError }}</div>
                            <!-- looped thumnail images -->
                            <div>
                                <div class="image_holder" v-for="(item, i) in addthumbnaildata.image" :key="i">
                                    <img :src="item.path" alt="No-Image" v-show="dynamic" class="product-image" height="80" width="137" preview />
                                    <span><img src="@/assets/layout/images/cross.svg" alt="" @click="removePreview1(i)" /></span>
                                </div>
                            </div>
                        </div>

                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <!-- <br><br> -->
                            <label for="subtitle2" id="match" style="color: transparent; opacity: 0"> 0 </label>
                            <p>{{ $t('OtherPlatform.Add.BGImage') }}</p>
                            <!-- <h5 id="subhead1"></h5> -->
                            <!-- file upload field  -->
                            <div :class="`${error.file ? 'custom-select-invalid' : 'custom-select'}`">
                                <span v-if="!fileName">{{ $t('OtherPlatform.Add.fileupload') }}</span>
                                <span v-else>{{ fileName }}</span>

                                <input type="file" class="select-file" accept="image/*" :multiple="true" @change="FileChangeBackground($event)" />
                                <Button :label="$t('OtherPlatform.Add.ChooseFile')" class="SelectBtn n-wrap" />
                            </div>

                            <span class="img-info">* {{ $t('OtherPlatform.Add.IMGINFO') }}</span>
                            <br />
                            <div class="text-red">{{ addImagePageData.maxImagelengthError }}</div>
                            <!-- looped Background images -->
                            <div>
                                <div class="image_holder" v-for="(item, i) in addImagePageData.image" :key="i">
                                    <img :src="item.path" alt="No-Image" v-show="dynamic" class="product-image" height="80" width="137" preview />
                                    <span><img src="@/assets/layout/images/cross.svg" alt="" @click="removePreview(i)" /></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3" v-show="direct_Input_center">
                        <div class="p-field p-col-12 p-md-4">
                            <label for="pass">{{ $t('OtherPlatform.Add.PostStartDate') }}<span class="redRequired">*</span></label>
                            <Calendar
                                :class="`${error.Noticesdt ? 'p-invalid' : ''}`"
                                :showIcon="true"
                                :minDate="today"
                                :showButtonBar="false"
                                v-model="notice_sdate"
                                dateFormat="yy-mm-dd"
                                placeholder="YYYY-MM-DD"
                                :manualInput="false"
                                @date-select="ClearError($event)"
                            >
                            </Calendar>
                            <small class="text-red">{{ error.Noticesdt }}</small>
                        </div>
                        <div class="p-field p-col-12 p-md-4" id="nohead">
                            <label for="pass">{{ $t('OtherPlatform.Add.PostEndDate') }}<span class="redRequired">*</span></label>
                            <Calendar
                                @click="mineDate = new Date(notice_sdate)"
                                :class="`${error.Noticeedt ? 'p-invalid' : ''}`"
                                :showIcon="true"
                                :minDate="mineDate"
                                :showButtonBar="false"
                                v-model="notice_edate"
                                dateFormat="yy-mm-dd"
                                placeholder="YYYY-MM-DD"
                                :manualInput="false"
                                @date-select="ClearError($event)"
                            >
                            </Calendar>
                            <small class="text-red">{{ error.Noticeedt }}</small>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <br />
            <br /> -->
            <div class="p-d-flex p-jc-end p-ai-center" style="float: left; margin-top: -10px">
                <Button :label="$t('OtherPlatform.Add.Save')" icon="pi pi-check" iconPos="left" class="p-button Black" @click="openResponsive1" style="margin-top: 0px"></Button>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center" style="float: right; margin-top: -10px">
                <Button :label="$t('OtherPlatform.Add.Back')" icon="pi pi-replay" iconPos="left" class="p-button p-button-outlined p-button p-mr-2" @click="openResponsive" style="margin-top: 0px; background: white; color: black"></Button>
            </div>
            <!-- <div class="p-d-flex p-jc-end p-ai-center">
                <div></div>
            </div> -->
        </form>
    </div>
    <Dialog modal :header="$t('OtherPlatform.Add.Alert')" v-model:visible="displayResponsive" :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '21vw' }">
        <p class="text-choose">
            <b>{{ $t('OtherPlatform.Add.ConfirmText') }}</b>
        </p>
        <div class="p-grid p-formgrid p-mb-3">
            <div class="p-col-12 p-mb-2 p-lg-12 p-mb-lg-0 p-field">
                <b id="head11">{{ $t('OtherPlatform.Add.ConfirmText2') }}</b>
            </div>
        </div>

        <template #footer>
            <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: left">
                <Button :label="$t('OtherPlatform.list.Confirm')" icon="pi pi-check" @click="$router.go(-1)" id="reject" />
            </div>
            <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: right">
                <Button :label="$t('OtherPlatform.list.Cancel')" icon="pi pi-replay" @click="closeResponsive" class="p-button p-button p-button-outlined" id="close" style="background: white; color: black" />
            </div>
        </template>
    </Dialog>
    <Dialog modal :header="$t('OtherPlatform.Add.Alert')" v-model:visible="displayResponsive1" :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '21vw' }">
        <p class="text-choose">
            <b>{{ $t('OtherPlatform.Add.ConfirmText3') }}</b>
        </p>
        <div class="p-grid p-formgrid p-mb-3">
            <div class="p-col-12 p-mb-2 p-lg-12 p-mb-lg-0 p-field">
                <b id="head11">{{ $t('OtherPlatform.Add.ConfirmText4') }}</b>
            </div>
        </div>

        <template #footer>
            <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: left">
                <Button :label="$t('OtherPlatform.list.Confirm')" icon="pi pi-check" @click="getfinalimagelist()" id="reject" />
            </div>
            <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: right">
                <Button :label="$t('OtherPlatform.list.Cancel')" icon="pi pi-replay" @click="closeResponsive1" class="p-button p-button p-button-outlined" id="close" style="background: white; color: black" />
            </div>
        </template>
    </Dialog>
    <Dialog v-model:visible="Adressmodal" class="closecross" :header="$t('OtherPlatform.Add.SearchAddress')" :style="{ width: '50vw' }">
        <VueDaumPostcode @complete="handleAddress"></VueDaumPostcode>
    </Dialog>
    <!-- <Dialog v-model:visible="prefmodal" class="closecross" closable="false" header="우대 조건을 선택하세요." :style="{ width: '50vw' }">
        <preferentialConditionVue @conditionData="setConditions($event)" ref="childprefcondition"></preferentialConditionVue>
        <template #footer>
            <Button label="저장" icon="pi pi-check" @click="(prefmodal = false), $refs.childprefcondition.sendCondition()" autofocus />
        </template>
    </Dialog> -->
    <!-- <Dialog v-model:visible="jobselectModal" class="daumheader" header="직무 선택" :style="{ width: '50vw' }">
        <jobselection @submit="getFilters($event)" ref="childjobselect"></jobselection>
        <template #footer>
            <Button label="저장" icon="pi pi-check" @click="(jobselectModal = false), $refs.childjobselect.submitFilter()" autofocus />
        </template>
    </Dialog> -->

    <div class="floatingModal" v-show="prefmodal">
        <div class="insideModal">
            <span class="croosAndcloseIcon" @click="prefmodal = false">&#10005;</span>
            <h4 class="modalHeaderone">우대조건 선택</h4>
            <div class="innerBox">
                <preferentialConditionVue @conditionData="setConditions($event)" ref="childprefcondition"></preferentialConditionVue>
            </div>
            <div class="footerbutton">
                <Button label="적용하기" icon="pi pi-check" @click="(prefmodal = false), $refs.childprefcondition.sendCondition()" autofocus />
            </div>
        </div>
    </div>
    <div class="floatingModal" v-show="jobselectModal">
        <div class="insideModalone">
            <span class="croosAndcloseIcon" @click="jobselectModal = false">&#10005;</span>
            <span class="croosAndcloseIcon2" @click="$refs.childjobselect.refreshAll($event)">&#x21BB;</span>
            <h4 class="modalHeaderone">직무선택</h4>
            <div class="innerBox2">
                <jobselection @submit="getFilters($event)" @selected_filters="getDatajobs($event)" ref="childjobselect"></jobselection>
            </div>
            <div class="footerbutton">
                <Button label="설정하기" icon="pi pi-check" @click="(jobselectModal = false), SubmitJob()" autofocus />
            </div>
        </div>
    </div>
</template>

<script>
// import axios from 'axios';
// import { useRoute } from 'vue-router';
// import OtherPlatformService from '../../service/API/OtherPlatformService';
import OtherPlatformService from '../../service/API/OtherPlatformService';
import preferentialConditionVue from './preferentialCondition.vue';
import jobselection from './jobSelection.vue';
import validatejobpost from '../../validations/PositionOffer/jobpostingValidate';
import moment from 'moment';
export default {
    name: 'Add',
    components: {
        preferentialConditionVue,
        jobselection,
    },
    // props: ['dog', 'image'],
    data() {
        return {
            selectedjobArray: [],
            today: new Date(),
            today2: new Date(),
            mineDate: new Date(),
            notice_sdate: '',
            notice_edate: '',
            anTitle: '',
            dynamic: true,
            workHr: true,
            //prefill data start
            PersonName: '',
            privatename: false,
            PersonContact: '',
            privatecontact: false,
            PersonEmail: '',
            privateemail: false,
            jobselectModal: false,
            AddressCheck: 'defaultAddress',
            dAddress: '',
            dPostcode: '',
            nAddress: '',
            nPostcode: '',
            lattitude: '',
            longitude: '',
            max: 6,
            privateaddress: false,
            addressdepth: {},
            gender: 'any',
            checkAgebetw: false,
            age_between: true,
            startAge: '',
            endAge: '',
            middle_age: false,
            educationLevel: 'no_academic_background',
            showEdcnLevel: false,
            selectededucation: 'university_4_years',
            preferentialCondition: [],
            selectedjob: [],
            areaRecruitment: '',
            noOfPeople: '',
            noOfPeople_visible: true,
            checknoPeople: false,
            responsible: '',
            eligibility: '',
            carrer: 'any',
            carrerField: true,
            min_exper: '',
            max_exper: '',
            regardlessAny: false,
            selectedWorkingType: '', //contract_worker
            probabation: '',
            selectedWorkingPeriod: '',
            negoWorkperiod: false,
            checkedDays: [],
            workhrTo: '', //18:00
            workhrFrom: '', //12:00
            BreakhrFrom: '', //12:00
            BreakhrTo: '', //13:00
            nobreak: false,
            Paysalary: '', //10000000
            prescribedWorkHours: '', //40
            NoticePostPeriod: '7_days',
            direct_Input_center: false,
            //upload image
            addImagePageData: {
                list: [],
                image: [],
                videoUrl: '',
                type: '',
                maxImagelengthError: '',
            },
            thumbnailRes: [],
            backgroundRes: [],
            allfinalbgAry: [],
            bgAry: [],
            addthumbnaildata: {
                list: [],
                image: [],
                videoUrl: '',
                type: '',
                maxImagelengthError: '',
            },
            //prefill data end
            prefillData: {},
            Adressmodal: false,
            prefmodal: false,
            modalshow: false,
            render1: false,
            render2: false,
            name: '',
            email: '',
            phone: '',
            menus: [],
            time1: '',
            time2: '',
            time3: '',
            time4: '',
            selectday: '',
            WorkingDay: 'selectday',
            displayResponsive: false,
            displayResponsive1: false,
            job_detail_address: '',
            Genderdropdown: [
                { name: '남자', code: 'male' },
                { name: '여자', code: 'female' },
                { name: '성별무관', code: 'any' },
            ],
            Genderdropdowns: '',
            Qualificationdropdown: [
                { text: '초등학교', value: 'elementary_school' },
                { text: '중학교', value: 'middle_school' },
                { text: '고등학교', value: 'high_school' },
                { text: '대학(2,3년제)', value: 'university_2_or_3_years' },
                { text: '대학(4년제)', value: 'university_4_years' },
                { text: '대학원', value: 'graduate_school' },
            ],
            Qualificationdropdowns: '',
            Careerdropdown: [
                { name: '경력무관', code: 'any' },
                { name: '신입', code: 'newcomer' },
                { name: '경력(초급)', code: 'elementary' },
                { name: '경력(중급)', code: 'intermediate' },
                { name: '경력(고급)', code: 'advanced' },
                { name: '경력(직접 입력)', code: 'experience' },
            ],
            Careerdropdowns: '',
            workingType: [
                // { text: "선택", value: "" },
                { text: '아르바이트', value: 'part_time_job' },
                { text: '정규직', value: 'full_time' },
                { text: '계약직', value: 'contract_worker' },
                { text: '파견직', value: 'dispatch' },
                { text: '인턴직', value: 'internship' },
                { text: '프리랜서', value: 'freelancer' },
                { text: '기타', value: 'etc' },
            ],

            workingPeriod: [
                // { text: "선택", value: "" },
                { text: '하루(1일)', value: '1_day' },
                { text: '1주일이하', value: 'less_than_1_week' },
                { text: '1주일~1개월', value: '1_week_to_1_month' },
                { text: '1개월~3개월', value: '1_month_to_3_months' },
                { text: '3개월~6개월', value: '3_months_to_6_months' },
                { text: '6개월~1년', value: '6_months_to_1_year' },
                { text: '1년 이상', value: 'more_than_1_year' },
            ],
            workingDays: [
                {
                    dayName: '월',
                    val: 1,
                },
                {
                    dayName: '화',
                    val: 2,
                },
                {
                    dayName: '수',
                    val: 3,
                },
                {
                    dayName: '목',
                    val: 4,
                },
                {
                    dayName: '금',
                    val: 5,
                },
                {
                    dayName: '토',
                    val: 6,
                },
                {
                    dayName: '일',
                    val: 7,
                },
            ],
            payTypes: [
                { text: '시급', value: 'hourly_wage' },
                { text: '일급', value: 'daily_wage' },
                { text: '월급', value: 'salary' },
            ],
            payType: 'daily_wage',
            noticePostingPeriod: [
                { text: '7일', value: '7_days' },
                { text: '15일', value: '15_days' },
                { text: '1개월', value: '1_month' },
                { text: '직접입력', value: 'direct_input' },
            ],
            formData: new FormData(),
            error: {},
            errage: '',
        };
    },
    created() {
        this.otherPlatformService = new OtherPlatformService();
    },
    mounted() {
        this.otherPlatformService
            .getprefillIdDetails(this.$route.params.reqId)
            .then((res) => {
                console.log(res.data);
                this.prefillData = res.data;
                this.PersonName = res.data.company_info.contact_person;
                this.PersonContact = res.data.phone_number;
                this.PersonEmail = res.data.email;
                this.dAddress = res.data.company_info.company_address;
                this.dPostcode = res.data.company_info.company_postal_code;
                this.lattitude = res.data.lat;
                this.longitude = res.data.long;
                this.addressdepth.region_1depth_name = res.data.region_1st_depth;
                this.addressdepth.region_2depth_name = res.data.region_2nd_depth;
                this.addressdepth.region_3depth_name = res.data.region_3rd_depth;
                this.acceptJobpost();
            })
            .catch((err) => console.log(err));
    },
    methods: {
        checkAgeOrder() {
            if (this.startAge != '' && this.endAge != '') {
                if (this.startAge > this.endAge) {
                    this.errage = '나이를 확인해 주세요.';
                } else {
                    this.errage = '';
                }
                if (this.endAge >= 45) {
                    this.middle_age = true;
                } else {
                    this.middle_age = false;
                }
            } else {
                this.middle_age = false;
            }
        },
        SubmitJob() {
            this.$refs.childjobselect.submitFilter();
            setTimeout(() => {
                this.ClearError();
            }, 200);
        },
        ClearError() {
            if (this.startAge.length === 0) {
                this.error.mnAge = '이 필드(주소)를 작성하십시오.';
            } else {
                this.error.mnAge = '';
            }
            if (this.endAge.length === 0) {
                this.error.mxAge = '이 필드(주소)를 작성하십시오.';
            } else {
                this.error.mxAge = '';
            }
            if (this.areaRecruitment.length === 0) {
                this.error.jobRequirement = '이 필드를 작성하십시오.';
            } else {
                this.error.jobRequirement = '';
            }
            if (this.noOfPeople.length === 0) {
                this.error.jobNopeople = '이 필드를 작성하십시오.';
            } else {
                this.error.jobNopeople = '';
            }
            if (this.responsible.length === 0) {
                this.error.responsibility = '이 필드를 작성하십시오 (책임).';
            } else {
                this.error.responsibility = '';
            }
            if (this.eligibility.length === 0) {
                this.error.qualification = '이 필드를 작성하십시오 (자격).';
            } else {
                this.error.qualification = '';
            }
            if (this.selectedWorkingType === '') {
                this.error.wType = '근무 기간을 입력해 주세요.';
            } else {
                this.error.wType = '';
            }
            if (this.selectedWorkingPeriod === '') {
                this.error.wPeriod = '근무 기간을 입력해 주세요.';
            } else {
                this.error.wPeriod = '';
            }
            if (this.checkedDays.length === 0) {
                this.error.wdays = '요일을 선택해 주세요';
            } else {
                this.error.wdays = '';
            }
            if (this.workhrFrom === '') {
                this.error.wrkHrfrm = '필수 입력 사항입니다.';
            } else {
                this.error.wrkHrfrm = '';
            }
            if (this.workhrTo === '') {
                this.error.wrkHrto = '필수 입력 사항입니다.';
            } else {
                this.error.wrkHrto = '';
            }
            if (this.prescribedWorkHours === '') {
                this.error.pWorkHr = '필수 입력 사항입니다.';
            } else {
                this.error.pWorkHr = '';
            }
            if (this.Paysalary === '') {
                this.error.salary = '필수 입력 사항입니다.';
            } else {
                this.error.salary = '';
            }
            if (this.anTitle === '') {
                this.error.atitle = '공고 제목을 입력해 주세요.';
            } else {
                this.error.atitle = '';
            }
            if (this.notice_sdate === '') {
                this.error.Noticesdt = '이 필드를 작성하십시오.';
            } else {
                this.error.Noticesdt = '';
            }
            if (this.notice_edate === '') {
                this.error.Noticeedt = '이 필드를 작성하십시오.';
            } else {
                this.error.Noticeedt = '';
            }
            if (this.jobSelect === '') {
                this.error.jobSelect = '버튼을 클릭하여 작업을 선택하십시오.';
            } else {
                this.error.jobSelect = '';
            }
        },
        validateTime() {
            if (moment(this.workhrFrom, 'HH:mm', true).isValid()) {
                // Time is valid, do something with it
                console.log('Valid time:', this.workhrFrom);
            } else {
                // Time is invalid
                console.log('Invalid time');
            }
        },
        validateTime1() {
            if (moment(this.workhrTo, 'HH:mm', true).isValid()) {
                // Time is valid, do something with it
                console.log('Valid time:', this.workhrTo);
            } else {
                // Time is invalid
                console.log('Invalid time');
            }
        },
        validateTime2() {
            if (moment(this.BreakhrFrom, 'HH:mm', true).isValid()) {
                // Time is valid, do something with it
                console.log('Valid time:', this.BreakhrFrom);
            } else {
                // Time is invalid
                console.log('Invalid time');
            }
        },
        validateTime3() {
            if (moment(this.BreakhrTo, 'HH:mm', true).isValid()) {
                // Time is valid, do something with it
                console.log('Valid time:', this.BreakhrTo);
            } else {
                // Time is invalid
                console.log('Invalid time');
            }
        },
        acceptJobpost() {
            this.otherPlatformService
                .acceptJob(this.$route.params.id)
                .then((res) => {
                    console.log(res);
                })
                .catch((err) => console.log(err));
        },
        formatDate(value) {
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = yyyy + '-' + mm + '-' + dd);
        },
        onlyNumber($event) {
            let keyCode = $event.keyCode ? $event.keyCode : $event.which;
            if (keyCode < 48 || keyCode > 57) {
                // 46 is dot
                $event.preventDefault();
            }
        },
        getfinalimagelist() {
            const thumbAry = this.thumbnailRes === [] ? [] : [this.thumbnailRes];
            const bgAry = this.bgAry;
            if (thumbAry.length <= 0) {
                this.allfinalbgAry = bgAry;
                console.log('allfinalbgAry', this.allfinalbgAry);
            } else if (bgAry.length <= 0) {
                this.allfinalbgAry = thumbAry;
                console.log('allfinalbgAry', this.allfinalbgAry);
            } else if (thumbAry.length <= 0 && bgAry.length <= 0) {
                this.allfinalbgAry = [];
                console.log('allfinalbgAry', this.allfinalbgAry);
            } else {
                this.allfinalbgAry = [...thumbAry, ...bgAry];
                console.log('allfinalbgAry', this.allfinalbgAry);
            }
            console.log(this.NoticePostPeriod);
            let vcheckData = {
                mName: this.PersonName,
                mContact: this.PersonContact,
                mEmail: this.PersonEmail,
                cPIN: this.AddressCheck == 'newAddress' ? this.nPostcode : this.dPostcode,
                cAddr: this.AddressCheck == 'newAddress' ? this.nAddress : this.dAddress,
                mnAge: this.checkAgebetw == false ? this.startAge : 'something',
                mxAge: this.checkAgebetw == false ? this.endAge : 'something',
                //talentInfo
                jobSelect: this.selectedjob.length == 0 ? '' : 'something',
                jobRequirement: this.areaRecruitment,
                jobNopeople: this.checknoPeople == false ? this.noOfPeople : 'something',
                responsibility: this.responsible,
                qualification: this.eligibility,
                minExp: this.carrer == 'experience' ? this.min_exper : 'something',
                maxExp: this.carrer == 'experience' ? this.max_exper : 'something',
                //working Condition
                wType: this.selectedWorkingType,
                wPeriod: this.selectedWorkingPeriod,
                wdays: this.checkedDays.length <= 0 && this.WorkingDay != 'negotiate' ? '' : 'something',
                wrkHrfrm: this.workhrFrom != '' ? 'something' : '',
                wrkHrto: this.workhrTo != '' ? 'something' : '',
                salary: this.Paysalary,
                pWorkHr: this.prescribedWorkHours,
                //final step
                atitle: this.anTitle,
                nPeriod: this.NoticePostPeriod,
                Noticeedt: this.NoticePostPeriod == 'direct_input' ? this.notice_edate.toString() : 'something',
                Noticesdt: this.NoticePostPeriod == 'direct_input' ? this.notice_sdate.toString() : 'something',
            };
            console.log(this.direct_Input_center);
            const { isInvalid, error } = validatejobpost(vcheckData);
            if (isInvalid) {
                this.displayResponsive1 = false;
                this.error = error;
                console.log(error);
            } else {
                setTimeout(() => {
                    this.addJob();
                }, 500);
            }
        },
        addJob() {
            // console.log('post Id', this.$route.params.id);
            let inputData = {
                other_platform_request_id: this.$route.params.id,
                contact_name: this.PersonName,
                is_private_name: this.privatename == true ? 1 : 0,
                contact_person_num: this.PersonContact,
                is_private_person_num: this.privatecontact == true ? 1 : 0,
                contact_email: this.PersonEmail,
                is_private_email: this.privateemail == true ? 1 : 0,
                workarea_code: this.nPostcode != '' ? this.nPostcode : this.dPostcode,
                workarea_address: this.nAddress != '' ? this.nAddress : this.dAddress,
                is_private_address: this.privateaddress == true ? 1 : 0,
                region_1st_depth: this.addressdepth.region_1depth_name,
                region_2nd_depth: this.addressdepth.region_2depth_name,
                region_3rd_depth: this.addressdepth.region_3depth_name,
                lat: this.addressdepth.y == undefined ? this.lattitude : this.addressdepth.y,
                long: this.addressdepth.x == undefined ? this.longitude : this.addressdepth.x,
                gender: this.gender,
                age: this.checkAgebetw == true ? 'manual' : 'any',
                mid_age_value: this.middle_age == true ? 45 : null,
                start_age: this.startAge == '' ? null : this.startAge,
                end_age: this.endAge == '' ? null : this.endAge,
                education: this.educationLevel == 'no_academic_background' ? 'no_academic_background' : this.selectededucation,
                occupations: this.selectedjob,
                areas_of_recruitment: this.areaRecruitment,
                num_of_recruitment: this.noOfPeople,
                is_num_of_recruitment_undecided: this.checknoPeople == true ? 1 : 0,
                preferential_conditions: this.preferentialCondition,
                pictures: this.allfinalbgAry,
                responsibilities: this.responsible,
                eligibilities: this.eligibility,
                career: this.carrer,
                min_experience: this.min_exper == '' ? null : this.min_exper,
                max_experience: this.max_exper == '' ? null : this.max_exper,
                any_experience: this.regardlessAny == true ? 1 : 0,
                working_mode: this.selectedWorkingType,
                probation: this.probabation,
                working_period: this.selectedWorkingPeriod,
                negotiable_working_period: this.negoWorkperiod == true ? 1 : 0,
                negotiable_working_days: this.workingDay == 'negotiate' ? 1 : 0,
                working_days: this.checkedDays,
                pay_type: this.payType,
                salary: this.Paysalary,
                // working_hour_from: this.formatTime(this.workhrFrom),
                // working_hour_end: this.formatTime(this.workhrTo),
                // break_time_from: this.formatTime(this.BreakhrFrom) == 'NaN:NaN' ? null : this.formatTime(this.BreakhrFrom),
                // break_time_end: this.formatTime(this.BreakhrTo) == 'NaN:NaN' ? null : this.formatTime(this.BreakhrTo),
                working_hour_from: this.workhrFrom,
                working_hour_end: this.workhrTo,
                break_time_from: this.BreakhrFrom == 'NaN:NaN' ? null : this.BreakhrFrom,
                break_time_end: this.BreakhrTo == 'NaN:NaN' ? null : this.BreakhrTo,
                no_break_time: this.nobreak == true ? 1 : 0,
                prescribed_working_hours: this.prescribedWorkHours,
                announcement_title: this.anTitle,
                notice_posting_period: this.NoticePostPeriod,
                notice_posting_period_custom_start_date: this.notice_sdate == '' ? null : this.formatDate(this.notice_sdate),
                notice_posting_period_custom_end_date: this.notice_edate == '' ? null : this.formatDate(this.notice_edate),
                job_detail_address: this.job_detail_address == '' ? null : this.job_detail_address,
            };
            this.otherPlatformService
                .saveJob(inputData)
                .then((res) => {
                    console.log(res);
                    this.$toast.add({ severity: 'success', summary: '확인.', detail: '공고가 성공적으로 등록되었습니다.', life: 3000 });
                    setTimeout(() => {
                        this.$router.push({ name: 'Post Other Platform Request' });
                    }, 500);
                })
                .catch((err) => console.log(err));
        },
        setConditions(data) {
            console.log(data);
            this.preferentialCondition = data;
        },
        formatTime(utcTime) {
            const utcDate = new Date(utcTime);
            // Create a new Date object for the given time
            const date = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60 * 1000);

            // Get the hours and minutes as two-digit strings
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');

            // Return the formatted time string
            return `${hours}:${minutes}`;
        },
        directInput() {
            if (this.NoticePostPeriod == 'direct_input') {
                this.direct_Input_center = true;
            } else {
                this.direct_Input_center = false;
                // this.notice_sdate = "";
                // this.notice_edate = "";
            }
        },
        breakControl() {
            if (this.nobreak == true) {
                this.workHr = false;
                this.BreakhrFrom = '';
                this.BreakhrTo = '';
            } else {
                this.workHr = true;
            }
        },
        check: function (e) {
            if (e.target.checked) {
                console.log(e.target.value);
            }
            this.negoworkDays = 0;
        },
        showCarrierField() {
            console.log(this.carrer);
            if (this.carrer == 'experience') {
                this.carrerField = true;
            } else {
                this.carrerField = false;
                this.min_exper = null;
                this.max_exper = null;
            }
        },
        removeFilter1(i, $event) {
            this.$refs.childjobselect.removeFilter(i, $event);
            setTimeout(() => {
                this.$refs.childjobselect.submitFilter();
            }, 300);
        },
        checkeducation() {
            if (this.educationLevel == 'no_academic_background') {
                this.showEdcnLevel = false;
                this.education = 'no_academic_background';
            } else {
                this.showEdcnLevel = true;
                this.education = this.select;
            }
        },
        setdepth(searchdata) {
            fetch(`https://dapi.kakao.com/v2/local/search/address.json?query=${searchdata}`, {
                method: 'get',
                headers: {
                    Authorization: `KakaoAK 5118e62bb72b728896d88de20f4b265b`,
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    this.addressdepth = data.documents[0].address;
                    console.log('Success0depth:', data.documents[0].address);
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        },
        handleAddress(data) {
            console.log(data);
            this.nPostcode = data.zonecode;
            console.log(this.nPostcode);
            this.nAddress = data.address;
            this.setdepth(data.address);
            this.Adressmodal = false;
        },
        reinitialize() {
            (this.name = null), (this.email = null), (this.phone = null), (this.menus = null);
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        preventLeadingSpace(e) {
            // only prevent the keypress if the value is blank
            if (!e.target.value) e.preventDefault();
            // otherwise, if the leading character is a space, remove all leading white-space
            else if (e.target.value[0] == ' ') e.target.value = e.target.value.replace(/^\s*/, '');
        },
        openResponsive() {
            this.displayResponsive = true;
        },
        closeResponsive() {
            this.displayResponsive = false;
        },
        openResponsive1() {
            this.displayResponsive1 = true;
        },
        closeResponsive1() {
            this.displayResponsive1 = false;
        },
        getFilters(event) {
            console.log(event);
            this.selectedjob = event;
            this.jobselectModal = false;
        },
        getDatajobs(event) {
            console.log(event);
            this.selectedjobArray = event;
            // this.jobselectModal = false;
        },
        //image upload related functions
        FileChangeBackground(evt) {
            console.log('bgggggg');
            this.bgImageList = [];
            let count = this.addImagePageData.image.length + evt.target.files.length;
            if (count <= 3) {
                this.addImagePageData.maxImagelengthError = '';
                for (let i = 0; i < evt.target.files.length; i++) {
                    // // max 50 mb exceeds
                    if (evt.target.files[i].size > 5000000 || !/\.(jpg|png|jpeg)$/i.test(evt.target.files[i].name)) {
                        console.log('max 50 mb exceeds');
                    } else {
                        let reader = new FileReader();
                        reader.onload = (event) => {
                            this.addImagePageData.image.push({
                                name: evt.target.files[i].name,
                                binary: evt.target.files[i],
                                path: event.target.result,
                            });
                        };
                        console.log(this.addImagePageData.image);
                        reader.readAsDataURL(evt.target.files[i]);
                    }
                }
                setTimeout(() => {
                    this.uploadbgFile();
                }, 300);
            } else {
                this.addImagePageData.maxImagelengthError = '이미지는 최대 3개까지 업로드 가능합니다.';
            }
        },

        async uploadbgFile() {
            let formData = new FormData();
            // formData.append('files[' + i + ']', file);
            for (let i in this.addImagePageData.image) {
                formData.append('images', this.addImagePageData.image[i].binary);
            }
            await this.otherPlatformService
                .saveBgImage(formData)
                .then((res) => {
                    this.backgroundRes = res.data;
                    // console.log('background_Image', this.backgroundRes);
                    let newbgImage = this.backgroundRes.map((obj) => {
                        return { ...obj, type: 'background' };
                    });
                    // name,
                    let finalBgImage = newbgImage.map(({ name, ...rest }) => {
                        console.log('name', name);
                        return rest;
                    });
                    console.log('Final-Background-Image', finalBgImage);
                    this.bgAry = finalBgImage;
                })
                .catch((err) => console.log(err));
        },
        async uploadThumbFile() {
            let formData = new FormData();
            // formData.append('files[' + i + ']', file);
            for (let i in this.addthumbnaildata.image) {
                formData.append('image', this.addthumbnaildata.image[i].binary);
            }
            await this.otherPlatformService
                .saveThumnailImage(formData)
                .then((res) => {
                    this.thumbnailRes = res.data;
                    console.log('Thumbnail_Image', this.thumbnailRes.name);
                    delete this.thumbnailRes.name;
                    this.thumbnailRes.type = 'thumbnail';
                    console.log('Final-Thumbnail-Image', this.thumbnailRes);
                })
                .catch((err) => console.log(err));
        },
        FileChangeThumnail(evt) {
            this.ThumbImageList = [];
            let count = this.addthumbnaildata.image.length + evt.target.files.length;
            if (count <= 1) {
                this.addthumbnaildata.maxImagelengthError = '';
                for (let i = 0; i < evt.target.files.length; i++) {
                    // // max 50 mb exceeds
                    if (evt.target.files[i].size > 5000000 || !/\.(jpg|png|jpeg)$/i.test(evt.target.files[i].name)) {
                        console.log('max 50 mb exceeds');
                    } else {
                        let reader = new FileReader();
                        reader.onload = (event) => {
                            this.addthumbnaildata.image.push({
                                name: evt.target.files[i].name,
                                binary: evt.target.files[i],
                                path: event.target.result,
                            });
                        };
                        console.log(this.addthumbnaildata.image);
                        reader.readAsDataURL(evt.target.files[i]);
                    }
                }
                setTimeout(() => {
                    this.uploadThumbFile();
                }, 300);
            } else {
                this.addthumbnaildata.maxImagelengthError = '이미지는 최대 1개까지 업로드 가능합니다.';
            }
        },
        removePreview(i) {
            this.addImagePageData.image.splice(i, 1);
        },
        removePreview1(i) {
            this.addthumbnaildata.image.splice(i, 1);
        },

        // async Add() {
        //       let vcheckData = {
        //           //     category_id: this.category_id.toString(),
        //           name: this.name,
        //           email: this.email,
        //           phone: this.phone,
        //           menus: this.menus.toString(),
        //           //     top_10: this.top_10,
        //           //     state: this.status,
        //           //     // type: this.dropdownValueType == null ? '' : 'something',
        //       };
        //       const { isInvalid, error } = validateCreateOtherPlatform(vcheckData);
        //       if (isInvalid) {
        //           this.error = error;
        //       } else {
        //           try {
        //             const url = '/api/v1/OtherPlatform/user/OtherPlatform-add';
        //             return await axios.post(url, { name: this.name, email: this.email, phone: this.phone, menus: this.menus.toString() }).then(() => {
        //             // alert('성공적으로 저장');
        //             this.$router.push({ name: 'OtherPlatform Management' });
        //             setTimeout(() => {
        //                 this.$toast.add({ severity: 'success', summary: '확인됨', detail: '계정 생성 성공', life: 3000 });
        //             }, 500);
        //         });
        //           } catch(error){
        //             let getError = error.response.data
        //             console.log(getError.error)
        //             if(getError.error == 'PhoneAlreadyExists'){
        //                 let errorText = '이미 존재하는 전화번호 입니다'
        //                 this.$toast.add({ severity: 'error', summary: '확인됨', detail: errorText, life: 3000 });
        //             } else if(getError.error == 'emailAlreadyExists'){
        //                 let errorText = '이미 존재하는 이메일 입니다'
        //                 this.$toast.add({ severity: 'error', summary: '확인됨', detail: errorText, life: 3000 });
        //             }
        //           }
        //       }
        //   },

        // Add() {
        //     let vcheckData = {
        //         //     category_id: this.category_id.toString(),
        //         name: this.name,
        //         email: this.email,
        //         phone: this.phone,
        //         menus: this.menus.toString(),
        //         //     top_10: this.top_10,
        //         //     state: this.status,
        //         //     // type: this.dropdownValueType == null ? '' : 'something',
        //     };
        //     const { isInvalid, error } = validateCreateOtherPlatform(vcheckData);
        //     if (isInvalid) {
        //         this.error = error;
        //         console.log(error);
        //     } else {
        //         console.log(this.formData);
        //         return axios.post('/api/v1/OtherPlatform/user/OtherPlatform-add', { name: this.name, email: this.email, phone: this.phone, menus: this.menus.toString() }).then((response) => {
        //             // alert('성공적으로 저장');
        //             console.log(response)
        //             // if (response.status === '400') {
        //             //     alert('Phone Number Already Exist');
        //             //     // this.error = ''
        //             // }
        //             // else {
        //                 this.$router.push({ name: 'OtherPlatform Management' });
        //                 setTimeout(() => {
        //                     this.$toast.add({ severity: 'success', summary: '확인됨', detail: '계정 생성 성공', life: 3000 });
        //                 }, 500);
        //             // }
        //         });
        //     }
        // },
    },
};
</script>

<style scoped>
.product-image {
    width: 100px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
.redRequired {
    color: #df1b3f;
}
.card.company {
    height: auto !important;
}
.img-info {
    font-size: 11px;
    font-weight: 400;
    color: rgb(48, 48, 48);
}

.custom-select {
    position: relative;
    border: 1px solid #cecece;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}

.custom-select-invalid {
    position: relative;
    border: 1px solid red;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}

.select-file {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0%;
    z-index: 5;
    opacity: 0;
}

.SelectBtn {
    max-width: 100px;
}

.custom-select span {
    max-width: 140px;
    display: inline-block;
    /* overflow: hidden; */
    white-space: nowrap;
    text-overflow: ellipsis;
}

.p-button {
    background: #000000;
    border: 1px solid #0a0a0a;
    color: white;
}

div#accesscheck {
    margin-top: 10px;
    /* line-height: 30px; */
    display: flex;
}

button.p-button.p-component.p-button.Black {
    background: black;
    color: white;
}
.card {
    height: 100%;
}
button#find {
    width: auto;
    margin-top: 0px;
}
input#Age {
    width: 20%;
    height: 35px;
    margin-left: 14px;
    margin-top: 21px;
}
div#triple {
    display: flex;
    margin: 0px 0px;
}
label#lbl {
    margin-top: 30px;
}
input#MS {
    margin-top: 35px;
    margin-left: -30px;
}
input#Middle-Aged-Recruitment {
    margin-left: 10px;
    margin-top: 20px;
}
label#lbl2 {
    margin-top: 27px;
}

label#lbl3 {
    margin-top: 20px;
}
input#ap {
    margin-top: 36px;
}
label#long {
    /* margin-left: 20px;
    margin-top: -40px; */
    display: contents;
}
.flex {
    display: flex;
    margin-left: -15px;
}
input#title2 {
    margin-top: 0px;
}
input#salary {
    margin-top: 25px;
}
p.text-choose {
    text-align: center;
    margin-top: 20px;
}
b#head11 {
    text-align: center;
    display: block;
}
div#flexradio {
    display: flex;
    /* width: auto; */
    justify-content: space-evenly;
}
label#txtlbl {
    margin-top: 8px;
    /* margin-left: -50px; */
}
div#Flexchecks {
    display: flex;
}
div#btnss {
    margin-top: 33px;
}
.image_holder {
    display: inline-block;
    position: relative;
    padding-right: 5px;
}
.image_holder span {
    position: absolute;
    right: 8px;
    top: 4px;
    border-radius: 50%;
    border: 1px solid #000;
    width: 20px;
    height: 20px;
    text-align: center;
    background-color: #fff;
}
.closecr > .p-dialog-header > .p-dialog-header-icons {
    display: none !important;
}
.floatingModal {
    position: fixed !important;
    display: flex;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    align-items: center;
    justify-content: center;
    z-index: 999;
}
.insideModal {
    min-width: 600px;
    padding: 15px 30px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.23);
    position: relative;
    border-radius: 15px;
    background-color: #fff;
    width: 70vw;
    max-height: 550px;
}
.insideModalone {
    padding: 15px 30px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.23);
    position: relative;
    border-radius: 15px;
    background-color: #fff;
    width: 63vw;
    height: 680px;
}
.innerBox {
    overflow: auto;
    height: 400px;
}
.innerBox2 {
    overflow: auto;
    height: 540px;
}
.croosAndcloseIcon {
    position: absolute;
    top: 15px;
    right: 15px;
    font-size: 22px;
    cursor: pointer;
}
.croosAndcloseIcon2 {
    position: absolute;
    top: 15px;
    right: 40px;
    font-size: 22px;
    cursor: pointer;
}
.footerbutton {
    background-color: #fff;
    padding: 10px 0;
    display: flex;
    justify-content: flex-end;
}
h3.modalHeaderone {
    margin: 0;
}
.p-input-icon-right > i:last-of-type {
    right: 0.5rem;
    color: #83888f;
    top: 18px;
}
small#valid1 {
    margin-left: 14px;
}
small#valid2 {
    margin-left: 15px;
}
small.info-text {
    margin-left: 18px;
    margin-top: 6px;
}
div#ttsss {
    margin-top: 5px;
}
div#checktext {
    margin-top: 15px;
}
small.text-info1 {
    line-height: 30px;
    margin-left: 10px;
}
small.text-info {
    margin-left: 18px;
}
.p-custom-grid-lg {
    flex-wrap: nowrap;
    white-space: nowrap;
}
.mt-error {
    margin-top: 0px;
    display: block;
    margin-left: 0px;
}
label.error-msgs {
    margin-top: 0 !important;
}
small#error {
    margin-left: 16px;
}
h5#subhead {
    font-size: 15px;
    font-weight: 200;
}
p#subhead {
    font-size: 15px;
    font-weight: 200;
}
label#match {
    margin-top: 1px;
}
.p-shadow-none {
    box-shadow: none;
}
</style>
